<template>
  <div>
    <base-crud
      crudName="Filiais"
      newText="Nova Filial"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "branchTable",
      pages: [],
      url: "",
      columns: [
        "id",
        "title",
        "building_name",
        "company_id",
        "city",
        "state",
        "actions",
      ],
      tableData: [
        "id",
        "title",
        "building_name",
        "company_id",
        "city",
        "state",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["title", "building_name", "company_id", "city", "state"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Título",
          building_name: "Prédio",
          company_id: "Empresa",
          city: "Cidade",
          state: "UF",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "branches/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        building_name: "building_name",
        company_id: "company[company_name]",
        city: "city",
        state: "state",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Branch/Crud.vue